import {ColDef, ColumnState, DateFilterModel, TextFilterModel, SetFilterModel} from 'ag-grid-community';
import {DatePipe} from '@angular/common';
import {Component, OnDestroy, OnInit, Output, EventEmitter, Input} from '@angular/core';
import {Store} from '@ngrx/store';
import {ToastrService} from 'ngx-toastr';
import {
  BehaviorSubject,
  combineLatest,
  filter,
  map,
  Observable,
  Subject,
  takeUntil,
  withLatestFrom,
} from 'rxjs';
import {
  selectAccountInfoSuccessfullyCompleted,
  selectIsEmployee
} from '../../../account-info-header/reducers';
import {InternalTransfersActions, TransactionFormActions} from '../../../create-request/actions';
import {
  amountColumnTemplate,
  currencyComparator,
  dateComparator,
  dateComparatorForFilter,
  defaultColumnTemplate,
  mapTransactionType
} from '../../../create-request/components/transactions-table/table-helpers';
import {ActionsLinkComponent} from '../../../shared/actions-link/actions-link.component';
import {agFilterNames} from '../../../shared/types/AgFilterNames';
import {TableComponentState} from '../../../shared/types/TableComponentState';
import {InitReleaseActions} from '../../actions';
import {
  Draft,
  DraftAttributes,
  DraftListAttributes,
  DraftListTableColumn,
} from '../../Models/Drafts/DraftResponse';
import {
  selectInitReleaseTableState,
  selectInitReleaseTransactionDeleteCallFailure,
  selectInitReleaseTransactionIsSloaFlow,
  selectInitReleaseTransactionsByDraftIdCallStarted,
  selectInitReleaseTransactionsByDraftIdCallSuccess,
  selectInitReleaseTransactionTable,
  selectInitReleaseTransactionTableReadyToLoad
} from '../../reducers';
import {AchExtraPrompts, ItExtraPrompts, WireTransactionDetails} from '../../../create-request/models/form/TransactionForm';
import {Router} from '@angular/router';
import {selectIsRecurring, selectTransactionForm} from '../../../create-request/reducers';
import {Constants, tableName, transactionTypes} from '../../../shared/utilities/Constants';
import {selectInitTab, selectInitTabForMasterAccount, selectPreferencesLoaded} from '../../../user-preference/reducers';
import {amountFormatter} from '../../../shared/utilities/AmountFormatter';
import {selectStandingAuthForm} from "../../../standing-authorizations/reducers";
import {
  StandingAuthCheckActions,
  StandingAuthFormActions,
  StandingAuthInternalTransferActions,
  StandingAuthWireActions
} from "../../../standing-authorizations/actions";
import { initiateAndReleaseComponentLoaded } from '../../../shared/actions/shared.actions';
import { SharedActions } from '../../../shared/actions';
import { WireStandingAuthDetails } from '../../../standing-authorizations/models/standingAuthorizationForm';
import { selectHasPositionLotsPhase2 } from '../../../authorize/reducers';
import { FeatureFlagService } from '../../../shared/services/feature-flag-service';
import { AccountInfoActions } from '../../../account-info-header/actions';
import { loadCreateStandingAuthEAuthClients, loadEAuthClients } from '../../../setup-eAuthorization/actions/eAuthorization.actions';
import { selectCreateStandingAuthtEauthClientCallSucessfullyCompleted, selectEauthClientCallSucessfullyCompleted } from '../../../setup-eAuthorization/reducers';
import { RemoveHyphenFromAccountPipe } from '../../../shared/pipes/remove-hyphen-from-account.pipe';
import { CoreService } from '@charlesschwab/sac-ui-core';
import { NamePipe } from '../../../shared/pipes/NamePipe';

@Component({
  standalone: false,
  selector: 'mm-init-release-transactions-table',
  templateUrl: './init-release-transactions-table.component.html',
  styleUrls: ['./init-release-transactions-table.component.scss'],
})
export class InitReleaseTransactionsTableComponent implements OnInit, OnDestroy {
  @Input() UserInContext: string;
  @Output() isDraftsServiceFailure = new EventEmitter<Boolean>();
  draftListsResponse: DraftListAttributes[];
  destroy$: Subject<boolean> = new Subject<boolean>();
  rowData$: Observable<DraftListTableColumn[]>;
  InRtableState$: Observable<TableComponentState>;
  isRecurring: boolean = false;
  hyphenPipe = new RemoveHyphenFromAccountPipe
  namePipe = new NamePipe();
  DraftListsubject = new Subject<DraftListTableColumn[]>();

  colNames = {
    masterAccount: 'Master account',
    subAccount: 'Sub Account',
    processDate: 'Process date',
    initiationDate: 'Initiation date',
    initiatorId: 'Initiator ID',
    toFromAccount: 'To/From',
    transactionType: 'Type',
    actions: 'Actions',
    status: 'Status',
    amount: 'Amount',
    incomingOROutgoing: 'Incoming/Outgoing',
  };

  columnDefs: ColDef[] = [];

  defColumnDefs: ColDef[] = [


    {
      field: this.colNames.processDate,
      comparator: dateComparator,
      filter: agFilterNames.date,
      filterParams: {
        comparator: dateComparatorForFilter,
        inRangeInclusive: true,
        browserDatePicker: true,
      },
      minWidth: 160,
      maxWidth: 160,
      cellClass: 'ag-ellipsis-cell',
    },
    {
      field: this.colNames.initiationDate,
      comparator: dateComparator,
      filter: agFilterNames.date,
      filterParams: {
        comparator: dateComparatorForFilter,
        inRangeInclusive: true,
        browserDatePicker: true,
      },
      minWidth: 160,
      maxWidth: 160,
      cellClass: 'ag-ellipsis-cell',
    },
    {
      field: this.colNames.initiatorId,
      filter: agFilterNames.set,
      floatingFilterComponent: 'customSetFloatingFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: true,
      },
      flex: 1,
      minWidth: 120,
      cellClass: 'ag-ellipsis-cell',
    },
    {
      field: this.colNames.transactionType,
      filter: agFilterNames.set,
      floatingFilterComponent: 'customSetFloatingFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: true,
      },
      flex: 1,
      minWidth: 250,
      cellClass: 'ag-ellipsis-cell',
    },
    {
      field: this.colNames.toFromAccount,
      floatingFilterComponent: 'customTextFloatingFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: true,
      },
      flex: 1,
      minWidth: 120,
      cellClass: 'ag-ellipsis-cell',
    },
    {
      field: this.colNames.incomingOROutgoing,
      filter: agFilterNames.set,
      floatingFilterComponent: 'customSetFloatingFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: true,
      },
      flex: 1,
      minWidth: 160,
      cellClass: 'ag-ellipsis-cell',
    },
    {
      field: this.colNames.amount,
      comparator: currencyComparator,
      floatingFilterComponent: 'customTextFloatingFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: true,
      },
      type: 'rightAligned',
      headerComponentParams: {template: amountColumnTemplate},
      minWidth: 120,
      width: 120,
      maxWidth: 140,
      cellClass: 'ag-ellipsis-cell',
    },
    {
      field: this.colNames.status,
      filter: agFilterNames.set,
      floatingFilterComponent: 'customSetFloatingFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: true,
      },
      width: 120,
      minWidth: 120,
      maxWidth: 130,
      cellClass: 'ag-ellipsis-cell',
    },
    {
      field: this.colNames.actions,
      filter: false,
      suppressMovable: true,
      sortable: false,
      cellRenderer: ActionsLinkComponent,
      cellRendererParams: {
        data: {
          isDraft: true,
        },
        viewStatus: 'View',
        review: 'Review',
        cancel: 'Cancel',
        delete: 'Delete',
        onClick: this.actionLinkClicked.bind(this),
      },
      minWidth: 220,
      maxWidth: 220,
      cellClass: 'ag-ellipsis-cell',
    },
  ];

  subAccountDefs: ColDef[] = [
    {
      field: this.colNames.subAccount,
      filter: agFilterNames.set,
      floatingFilterComponent: 'customSetFloatingFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: true,
      },
      flex: 1,
      minWidth: 120,
      cellClass: 'ag-ellipsis-cell',
    },
    ...this.defColumnDefs
  ];

  masterAccountDefs: ColDef[] = [
    {
      field: this.colNames.masterAccount,
      filter: agFilterNames.set,
      floatingFilterComponentParams: {
        suppressFilterButton: true,
      },
      flex: 1,
      minWidth: 120,
      cellClass: 'ag-ellipsis-cell',
    },
    ...this.defColumnDefs
  ];

  filterModel: {
    [key: string]: TextFilterModel | DateFilterModel | SetFilterModel;
  };

  fileName: string = 'pending-requests-';
  mockDraftAttributesEmptyOrWithContent: DraftListAttributes[] = [];
  isEmployee: boolean;
  currentDraftInContext$ = new BehaviorSubject<DraftListTableColumn | null>(null);
  deleteDraftClicked$ = new BehaviorSubject<boolean>(false);
  isSloaInContext: boolean = false;
  positionLotsPhase2EnabledFsg: boolean;

  constructor(private store: Store, private datepipe: DatePipe, private toastr: ToastrService, private router: Router, private featureFlagService: FeatureFlagService, private coreService: CoreService) {
  }

  ngOnInit() {
    this.store.dispatch(initiateAndReleaseComponentLoaded());

    this.columnDefs = this.isMasterAccountInContext ? this.subAccountDefs : this.masterAccountDefs;

    this.store.select(selectIsEmployee).subscribe((value) => {
      this.isEmployee = value;
    });

    this.store.select(selectIsRecurring).pipe(takeUntil(this.destroy$)).subscribe(isRecurring => {
      this.isRecurring = isRecurring;
    });

    this.store.select(selectHasPositionLotsPhase2).pipe(takeUntil(this.destroy$)).subscribe(val => {
      this.positionLotsPhase2EnabledFsg = val;
    });

    this.store.select(selectPreferencesLoaded)
      .pipe(
        takeUntil(this.destroy$),
        withLatestFrom(
          this.store.select(selectInitTab),
          this.store.select(selectInitTabForMasterAccount)
        ),
        filter(([loaded]) => loaded === true)
      ).subscribe(([loaded, tab, tabInitForMasterAccount]) => {
        if (tab && !this.isMasterAccountInContext) {
          this.columnDefs = this.buildColumnPreferences(tab.columns);
        }
        else if (tabInitForMasterAccount && this.isMasterAccountInContext) {
          this.columnDefs = this.buildColumnPreferences(tabInitForMasterAccount.columns);
        }
        else {
          this.columnDefs = this.isMasterAccountInContext ? this.subAccountDefs : this.masterAccountDefs;
        }
    });

    this.store.dispatch(InitReleaseActions.getInitReleaseList());

    this.rowData$ = this.store
      .select(selectInitReleaseTransactionTableReadyToLoad)
      .pipe(
        filter(state => !!state || state !== undefined),
        map((state) =>
          this.mapDraftListdataToRowData(state?.initReleaseTransactions ?? [], state?.initReleaseTransactionFails ?? false)
        )
      );

    this.InRtableState$ = this.store.select(selectInitReleaseTableState);

    this.store
      .select(selectInitReleaseTransactionDeleteCallFailure)
      .pipe(
        takeUntil(this.destroy$),
        filter((x) => x)
      )
      .subscribe(() => {
        this.toastr.error('Failed to cancel transaction');
      });

    this.store
      .select(selectInitReleaseTransactionsByDraftIdCallStarted)
      .pipe(
        takeUntil(this.destroy$),
        withLatestFrom(
          this.store.select(selectInitReleaseTransactionIsSloaFlow)
        )
      )
      .subscribe(([success, isSloa]) => {
        if (success) {
          if (isSloa) {
            this.store.dispatch(StandingAuthFormActions.loadReviewPage());
          } else {
            this.store.dispatch(TransactionFormActions.loadReviewPage());
          }
        }
      });

    this.store.select(selectInitReleaseTransactionsByDraftIdCallSuccess)
      .pipe(takeUntil(this.destroy$),
        withLatestFrom(
          this.store.select(selectInitReleaseTransactionIsSloaFlow),
          this.store.select(selectTransactionForm),
          this.store.select(selectStandingAuthForm))
      )
      .subscribe(([isSuccessful, isSloaFlow, transactionForm, standingAuthForm]) => {
        if (isSuccessful) {
          if (!isSloaFlow) {
            switch(transactionForm.transactionType) {
              case transactionTypes.wire:{
                  this.store.dispatch(TransactionFormActions.callWiresVerifyV3(transactionForm));
                break;
              }
              case transactionTypes.internalTransfer: {
                if ((transactionForm.extraPrompts as ItExtraPrompts)?.transferType?.includes('positions') && this.isMultipleToAccountFlow()) {
                  this.store.dispatch(TransactionFormActions.callInternalTransferListVerify({
                    transactionForm: transactionForm, isInRViewReviewFlow: true
                  }));
                } else {
                  this.store.dispatch(TransactionFormActions.callInternalTransferVerify({
                    transactionForm: transactionForm,
                    isInRViewReviewFlow: true
                  }));
                }
                break;
              }
              case transactionTypes.ach: {
                if((transactionForm.extraPrompts as AchExtraPrompts).frequency === "recurring"){
                  this.store.dispatch(TransactionFormActions.callAchAddProfileVerify({transactionForm:transactionForm, isInRViewReviewFlow:true}));
                }else {
                    this.store.dispatch(TransactionFormActions.callAchVerify(transactionForm));
                }
                break;
              }
              case transactionTypes.check: {
                if (this.isRecurring){
                  this.store.dispatch(TransactionFormActions.callRecurringCheckVerify(transactionForm));
                }else {
                  this.store.dispatch(TransactionFormActions.callOnetimeCheckVerify(transactionForm));
                }
                break;
              }
              default: {
                break;
              }
            }
          } else {
            switch(standingAuthForm.transactionType) {
              case transactionTypes.wire: {
                this.store.dispatch(StandingAuthWireActions.callWiresVerifyV3(standingAuthForm));
                break;
              }
              case transactionTypes.internalTransfer: {
                this.store.dispatch(StandingAuthInternalTransferActions.callInternalTransferVerify(standingAuthForm));
                break;
              }
              case transactionTypes.check: {
                this.store.dispatch(StandingAuthCheckActions.callVerify(standingAuthForm));
                break;
              }
              default: {
                break;
              }
            }
          }
        }
      });

    this.coreService.currentContextUpdated$
      .pipe(takeUntil(this.destroy$))
      .subscribe((context) => {
        this.store.dispatch(initiateAndReleaseComponentLoaded());
        this.store.dispatch(InitReleaseActions.getInitReleaseList());

        this.rowData$ = this.store
          .select(selectInitReleaseTransactionTableReadyToLoad)
          .pipe(
            filter(state => !!state || state !== undefined),
            map((state) =>
              this.mapDraftListdataToRowData(state?.initReleaseTransactions ?? [], state?.initReleaseTransactionFails ?? false)
            )
          );

        this.InRtableState$ = this.store.select(selectInitReleaseTableState);
    });
  }

  buildColumnPreferences(preferences: ColumnState[], isSavedTemplateTab: boolean = false): ColDef[] {
    let result: ColDef[] = preferences.map(preference => {
      switch (preference.colId) {
        case 'Master account':
          return {
            field: this.colNames.masterAccount,
            filter: agFilterNames.set,
            sort: preference.sort,
            floatingFilterComponentParams: {
              suppressFilterButton: true,
            },
            headerComponentParams: { template: defaultColumnTemplate },
            flex: 1,
            minWidth: 120,
            cellClass: 'ag-ellipsis-cell'
          }
          case 'Sub Account':
            return {
              field: this.colNames.subAccount,
              filter: agFilterNames.set,
              sort: preference.sort,
              floatingFilterComponent: 'customSetFloatingFilter',
              floatingFilterComponentParams: {
                suppressFilterButton: true,
              },
              headerComponentParams: { template: defaultColumnTemplate },
              flex: 1,
              minWidth: 120,
              cellClass: 'ag-ellipsis-cell'
            }
        case 'Process date':
          return {
            field: this.colNames.processDate,
            comparator: dateComparator,
            filter: agFilterNames.date,
            sort: preference.sort,
            filterParams: {
              comparator: dateComparatorForFilter,
              inRangeInclusive: true,
              browserDatePicker: true
            },
            headerComponentParams: { template: defaultColumnTemplate },
            minWidth: 160,
            maxWidth: 160,
            cellClass: 'ag-ellipsis-cell'
          }
        case 'Initiation date':
          return {
            field: this.colNames.initiationDate,
            comparator: dateComparator,
            filter: agFilterNames.date,
            sort: preference.sort,
            filterParams: {
              comparator: dateComparatorForFilter,
              inRangeInclusive: true,
              browserDatePicker: true
            },
            headerComponentParams: { template: defaultColumnTemplate },
            minWidth: 160,
            maxWidth: 160,
            cellClass: 'ag-ellipsis-cell'
          }
        case 'Initiator ID':
          return {
            field: this.colNames.initiatorId,
            filter: agFilterNames.set,
            sort: preference.sort,
            floatingFilterComponent: 'customSetFloatingFilter',
            floatingFilterComponentParams: {
              suppressFilterButton: true,
            },
            headerComponentParams: { template: defaultColumnTemplate },
            flex: 1,
            minWidth: 120,
            cellClass: 'ag-ellipsis-cell'
          }
        case 'Type':
          return {
            field: this.colNames.transactionType,
            filter: agFilterNames.set,
            sort: preference.sort,
            floatingFilterComponent: 'customSetFloatingFilter',
            floatingFilterComponentParams: {
              suppressFilterButton: true,
            },
            headerComponentParams: { template: defaultColumnTemplate },
            flex: 1,
            minWidth: 250,
            cellClass: 'ag-ellipsis-cell'
          }
        case 'To/From':
          return {
            field: this.colNames.toFromAccount,
            sort: preference.sort,
            floatingFilterComponent: 'customTextFloatingFilter',
            floatingFilterComponentParams: {
              suppressFilterButton: true,
            },
            headerComponentParams: { template: defaultColumnTemplate },
            filterParams: {
              textFormatter: (value: string) => value == null ? null : value.toLowerCase().replaceAll('-', '')
            },
            flex: 1,
            minWidth: 120,
            cellClass: 'ag-ellipsis-cell'
          }
        case 'Incoming/Outgoing':
          return {
            field: this.colNames.incomingOROutgoing,
            filter: agFilterNames.set,
            sort: preference.sort,
            floatingFilterComponent: 'customSetFloatingFilter',
            floatingFilterComponentParams: {
              suppressFilterButton: true,
            },
            headerComponentParams: { template: defaultColumnTemplate },
            flex: 1,
            minWidth: 160,
            cellClass: 'ag-ellipsis-cell'
          }
        case 'Amount':
          return {
            field: this.colNames.amount,
            comparator: currencyComparator,
            sort: preference.sort,
            floatingFilterComponent: 'customTextFloatingFilter',
            floatingFilterComponentParams: {
              suppressFilterButton: true,
            },
            filterParams: {
              textFormatter: (value: string) => value == null ? null : value.toLowerCase().replaceAll(',', '')
            },
            type: 'rightAligned',
            headerComponentParams: {template: amountColumnTemplate},
            minWidth: 120,
            width: 120,
            maxWidth: 140,
            cellClass: 'ag-ellipsis-cell'
          }
        case 'Actions':
          return {
            field: this.colNames.actions,
            filter: false,
            suppressMovable: true,
            sortable: false,
            cellRenderer: ActionsLinkComponent,
            cellRendererParams: {
              data: {
                isDraft: true
              },
              viewStatus: 'View',
              review: 'Review',
              cancel: 'Cancel',
              delete: 'Delete',
              onClick: this.actionLinkClicked.bind(this)
            },
            minWidth: 220,
            maxWidth: 220,
            cellClass: 'ag-ellipsis-cell'
          }
        case 'Status':
          return {
            field: this.colNames.status,
            filter: agFilterNames.set,
            sort: preference.sort,
            floatingFilterComponent: 'customSetFloatingFilter',
            floatingFilterComponentParams: {
              suppressFilterButton: true,
            },
            headerComponentParams: { template: defaultColumnTemplate },
            width: 120,
            minWidth: 120,
            maxWidth: 130,
            cellClass: 'ag-ellipsis-cell'
          }
        default:
          return {}
      }
    })
    return result;
  }

  mapDraftListdataToRowData(drafts: Draft[], draftsServiceFailureFlag: Boolean): DraftListTableColumn[] {
    this.isDraftsServiceFailure.emit(draftsServiceFailureFlag);
    if (drafts?.length === 0 || drafts === null || drafts === undefined) {
      drafts = [];
      this.store.dispatch(InitReleaseActions.hasEmptyResponse());
      return drafts.map((draft) => {
        return this.mapDrafts(draft.attributes);
      });
    }
    else
    {
      return drafts.map((draft) => {
        return this.mapDrafts(draft.attributes);
      });
    }
  }

  mapDrafts(draft: DraftAttributes): DraftListTableColumn {
    let isSloa = draft.formType.toLowerCase().includes('sloa');
    return {
      'Master account': draft.masterAccount.slice(0, 4) + '-' + draft.masterAccount.slice(4),
      'Sub Account': draft.subAccount.slice(0, 4) + '-' + draft.subAccount.slice(4),
      'Process date': isSloa ? ''
        : this.datepipe.transform(draft.transactionProcessDate, 'MM/dd/yyyy', 'UTC') ??
        'N/A',
      'Initiation date':
        this.datepipe.transform(draft.createDate, 'MM/dd/yyyy') ?? 'N/A',
      'Initiator ID': draft.createdByLoginId,
      Type: draft.party + ' - ' + mapTransactionType(draft.formType),
      'Incoming/Outgoing': draft?.fundsDirection === "I" ? "Incoming" : "Outgoing",
      'To/From': this.getToFrom(draft),
      Amount: isSloa ? '' : `${amountFormatter.format(draft.transactionAmount)}`,
      Status:
        draft.transactionStatus === 'deleted' && !isSloa
          ? 'Cancelled'
          : draft.transactionStatus.charAt(0).toUpperCase() + draft.transactionStatus.slice(1),
      DraftId: draft.draftId,
      isSloa: isSloa,
    };
  }

  getToFrom(draft: DraftAttributes): string {
    let transactionType = draft.transactionType;
    switch (transactionType) {
      case 'check': {
        let payeename1 =
          draft.payeeDetails?.payeeName1 != null &&
          draft.payeeDetails?.payeeName1 != ''
            ? draft.payeeDetails?.payeeName1
            : draft.payeeLine1 ?? '';
        let payeename2 =
          draft.payeeDetails?.payeeName2 != null &&
          draft.payeeDetails?.payeeName2 != ''
            ? draft.payeeDetails?.payeeName2
            : draft.payeeLine2 ?? '';
        let payeename3 =
          draft.payeeDetails?.payeeName3 != null &&
          draft.payeeDetails?.payeeName3 != ''
            ? draft.payeeDetails?.payeeName3
            : draft.payeeLine3 ?? '';
        let payeename = [payeename1, payeename2, payeename3].filter(x => !!x.trim()).join(" ");
        return payeename;
      }
      case 'wire': {
        return draft?.beneAccount ?? '';
      }
      case 'journal': {
        return draft?.toAccountId?.toString() ?? '';
      }
      case 'moneylink': {
        return this.namePipe.transform(
        `${draft?.FinancialInstitution} ${draft?.TransferAccount}`) ?? '';
      }
      default:
        return '';
    }
  }

  actionLinkClicked(event: any) {
    if (event.name === 'View') {
      this.viewClicked(event);
    }
    if (event.name === 'Cancel' || event.name === 'Delete') {
      this.cancelClicked(event);
    }
  }

  viewClicked(event: any) {
    let rowData = event.rowData;
    if (!rowData.isSloa) {
      this.store.dispatch(InternalTransfersActions.itClearToAccounts());
      this.store.dispatch(SharedActions.createRequestComponentLoaded());
    } else {
      this.store.dispatch(SharedActions.standingAuthComponentLoaded());
    }

    //DraftId Reset For Master Account in Context Review Page Open then Swapping to Subaccount
    this.coreService.currentContextUpdated$
      .pipe(takeUntil(this.destroy$))
      .subscribe((context) => {
          rowData = null;
    });

    // when master in context, don't call for draft until these 3 calls succeed
    // this follows call succession during sub acct in context, ensuring draft call isn't overwritten in store
    if (this.isMasterAccountInContext) {
      let subAccount = this.hyphenPipe.transform(rowData['Sub Account'])
      this.store.dispatch(AccountInfoActions.updateSubAccount({ accountId: subAccount }));
      this.store.dispatch(loadEAuthClients({ accountId: subAccount }));
      this.store.dispatch(loadCreateStandingAuthEAuthClients({ accountId: subAccount }));

      combineLatest([
        this.store.select(selectCreateStandingAuthtEauthClientCallSucessfullyCompleted),
        this.store.select(selectEauthClientCallSucessfullyCompleted),
        this.store.select(selectAccountInfoSuccessfullyCompleted)
      ])
        .pipe(takeUntil(this.destroy$),
          filter(([sloaEauthCallSuccess, eauthCallSuccess, accountInfoCallSuccess]) => 
            sloaEauthCallSuccess === true && 
            eauthCallSuccess === true && 
            accountInfoCallSuccess === true && 
            !!rowData
          ))
        .subscribe(([_sloaEauthCallSuccess, _eauthCallSuccess, _accountInfoCallSuccess]) => {
          this.store.dispatch(InitReleaseActions.callInitReleaseByDraftId({ draftId: rowData.DraftId, isSloa: rowData.isSloa }));
        });
    }

    else {
      this.store.dispatch(InitReleaseActions.callInitReleaseByDraftId({draftId: rowData.DraftId, isSloa: rowData.isSloa}));
    }
  }

  cancelClicked(event: any) {
    if (this.isEmployee) {
      this.toastr.error(Constants.toastrMessageEmployee);
    } else {
      this.isSloaInContext = event.rowData.isSloa;
      this.currentDraftInContext$.next(event.rowData);
      this.deleteDraftClicked$.next(true);
    }
  }

  isMultipleToAccountFlow(): boolean {
    return (typeof this.featureFlagService.featureFlags.positionLotsPhase2Enabled === 'boolean' && this.featureFlagService.featureFlags.positionLotsPhase2Enabled || this.positionLotsPhase2EnabledFsg);
  }

  get isMasterAccountInContext(): boolean {
    return this.UserInContext === 'MASTER';
  }

  get tableName(): tableName {
    return this.isMasterAccountInContext ? 'init master transactions view' : 'init';
  }

  ngOnDestroy() {
  }
}
